<template>
    <q-page padding>
        <q-tabs v-model="tab" color="white" text-color="primary" underline-color="primary" class="shadow-1 bg-white" align="justify">
            <q-tab slot="title" name="training" :label="$t('training')" icon="fal fa-graduation-cap" />

            <q-tab-pane name="training" class="q-px-md q-pb-xl q-mt-md">
                <div>
                    <div class="row gutter-sm" v-if="$q.platform.is.desktop">
                        <div class="col-sm-11">
                            <p class="q-title">{{ title }}</p>
                            <p class="q-body-1 text-weight-light">{{ description }}</p>
                        </div>

                        <div class="col-sm-1 cursor-pointer" @click="showCertificate()">
                            <vc-donut :sections="!course.is_open ? sections : []" :size="100" unit="%">
                                <h6 v-if="user_progress < 100 && group_training_user_result_status != 1 && group_training_user_result_status != 2 && !course.is_open" class="text-primary">
                                    {{ getPercentage(user_progress) }}%
                                </h6>

                                <q-icon :name="getResult" :color="getResultColor" size="2rem" v-if="user_progress == 100 || group_training_user_result_status == 1 || group_training_user_result_status == 2 && !course.is_open" />

                                <q-icon name="fal fa-clock" color="primary" size="2rem" v-if="course.is_open">
                                    <q-tooltip>
                                        {{ $t('this_course_is_being_published_your_progress_will_show_when_its_finished') }}
                                    </q-tooltip>
                                </q-icon>

                                <q-tooltip v-if="group_training_user_result_status == 2 && !course.is_open">
                                    {{ `${$t('you_were_reproved_in')} ${group_training_user_result_date}` }}
                                </q-tooltip>
                            </vc-donut>
                        </div>
                    </div>

                    <div class="row gutter-xs" v-if="$q.platform.is.mobile">
                        <div class="col-xs-10">
                            <p class="q-title">{{ title }}</p>
                        </div>

                        <div class="col-xs-2" @click="showCertificate()">
                            <vc-donut :sections="!course.is_open ? sections : []" :size="100" unit="%">
                                <h6 v-if="user_progress < 100 && group_training_user_result_status != 1 && group_training_user_result_status != 2" class="text-primary">
                                    {{ getPercentage(user_progress) }}%
                                </h6>

                                <q-icon :name="getResult" :color="getResultColor" size="1.5rem" v-if="user_progress == 100 || group_training_user_result_status == 1 || group_training_user_result_status == 2" />

                                <q-tooltip v-if="group_training_user_result_status == 2">
                                    {{ `${$t('you_were_reproved_in')} ${group_training_user_result_date}` }}
                                </q-tooltip>
                            </vc-donut>
                        </div>

                        <div class="col-xs-12 col-sm-11">
                            <p class="q-body-1 text-weight-light">{{ description }}</p>
                        </div>
                    </div>

                    <div class="row reverse gutter-sm q-mt-sm">
                        <div :class="$q.platform.is.ipad ? 'col-4' : 'col-xs-12 col-sm-2'" v-if="$route.name == 'course'">
                            <q-btn :label="$t('back')" color="primary" icon="far fa-chevron-left" class="full-width" @click="$router.push({ name: 'courses' })" />
                        </div>

                        <div :class="$q.platform.is.ipad ? 'col-4' : 'col-xs-12 col-sm-2'" v-if="$route.name == 'course' && owners">
                            <q-btn v-if="showDoubtsButton" :label="$t('doubts')" color="secondary" icon-right="fal fa-question-square" class="full-width" @click="doubts_modal = true" />
                        </div>

                        <div class="col-xs-12 col-sm-2" v-if="$route.name == 'trail_course'">
                            <q-btn :label="$t('back')" color="primary" icon="far fa-chevron-left" class="full-width" @click="$router.push({ name: 'trail', params: { id: $route.params.id_trail } })" />
                        </div>
                    </div>

                    <q-tabs v-model="tab_course" color="secondary" underline-color="primary" align="justify" class="q-mt-md">
                        <q-tab slot="title" name="activities" :label="$q.platform.is.desktop ? `${$t('activities')} (${qty_group_training_activities})` : ''" icon="fal fa-pen" />
                        <q-tab slot="title" name="support_materials" :label="$q.platform.is.desktop ? `${$t('support_materials')} (${qty_group_training_materials})` : ''" icon="fal fa-books" />
                        <q-tab slot="title" name="reaction_test" :label="$q.platform.is.desktop ? `${$t('reaction_test')} (${qty_group_training_evaluations})` : ''" icon="fal fa-clipboard-list-check" />
                        <q-tab slot="title" name="discussions" v-if="hasForum" :label="$q.platform.is.desktop ? `${$t(moduleName)} (${qty_group_training_discussions})` : ''" icon="fal fa-comments-alt" />

                        <q-tab-pane name="activities" class="q-px-md q-pb-md">
                            <activities @reloadActivity="reloadActivity" :course="course" />
                        </q-tab-pane>

                        <q-tab-pane name="support_materials" class="q-px-md q-pb-xl q-mt-md">
                            <support-materials />
                        </q-tab-pane>

                        <q-tab-pane name="reaction_test" class="q-px-md q-pb-xl q-mt-md">
                            <reaction-test />
                        </q-tab-pane>

                        <q-tab-pane name="discussions" class="q-px-xs q-pb-lg q-mt-xs">
                            <discussions />
                        </q-tab-pane>
                    </q-tabs>
                </div>
            </q-tab-pane>
        </q-tabs>

        <q-modal v-model="doubts_modal" :content-css="{minWidth: '60vw', minHeight: '40vh'}">
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense v-close-overlay icon="close" />
					<q-toolbar-title>{{ $t('doubts').toUpperCase() + '?' }}</q-toolbar-title>
				</q-toolbar>

				<div style="width:90%" class="row q-ma-md">
                    <div class="q-ma-sm col-xs-12 col-sm-6">
                        <q-input v-model="name" :float-label="$t('name')" :error="$v.name.$error" @input="$v.name.$touch" :disable="block_fields" />
                    </div>

                    <div class="q-ma-sm col-12">
                        <q-input type="email" v-model="email" :float-label="$t('email')" :error="$v.email.$error" @input="$v.email.$touch" :disable="block_fields" />
                    </div>

                    <div class="q-mx-sm q-mt-sm q-mb-xs col-12">
                        <q-input v-model="title" :float-label="$t('doubts_about_training')" :error="$v.email.$error" @input="$v.email.$touch" disable />
                    </div>

                    <div class="q-mb-md q-mx-sm q-pt-xs col-12">
                        <q-input type="textarea" rows="5" v-model="message" :float-label="$t('message')" :error="$v.message.$error" @input="$v.message.$touch" />
                    </div>
                </div>

				<q-toolbar slot="footer">
					<q-btn class="q-mx-sm" color="positive" :label="$t('send')" @click="askQuestion" />
					<q-btn class="q-mx-sm" color="negative" :label="$t('cancel')" @click="doubts_modal = false" />
				</q-toolbar>

			</q-modal-layout>
		</q-modal>

        <certificate :show="show_certificate" :data="certificate_data" :certificate="certificate" @hideCertificate="hideCertificate" />
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import Activities from 'components/course/Activities'
import ReactionTest from 'components/course/ReactionTest'
import SupportMaterials from 'components/course/SupportMaterials'
import Discussions from 'components/course/Discussions'
import Certificate from 'components/Certificate'
import { date } from 'quasar'
const { formatDate } = date
import { required, email, requiredIf } from 'vuelidate/lib/validators'

export default {
    i18nOptions: { namespaces: [ 'custom', 'common', 'courses', 'training', 'discussions'] },

    data() {
        return {
            tab: 'training',
            tab_course: 'activities',
            title: '',
            description: '',
            qty_group_training_activities: 0,
            qty_group_training_evaluations: 0,
            qty_group_training_materials: 0,
            qty_group_training_discussions: 0,
            user_progress: 0,
            group_training_user_result_status: null,
            sections: [],
            show_certificate: false,
            certificate_data: [],
            group_training_user_result_date: '',
            course: [],
            certificate: {},
            id_curse : '',
            id_trail: '',
            owners: null,
            doubts_modal: false,
            name: '',
            email: '',
            message: '',
            block_fields: false
        }
    },

    components: {
        'activities': Activities,
        'reaction-test': ReactionTest,
        'support-materials': SupportMaterials,
        'discussions': Discussions,
        'certificate': Certificate
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            name_store: 'common/full_name',
            email_store: 'common/email',
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        moduleName(){
            if (this.id_user_client_selected) {
                let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
                if(obj)  return obj.title_forum == '' ? 'discussions' : obj.title_forum
                else return 'discussions'
            }
            else return 'discussions'
        },

        getResult() {
            if (this.group_training_user_result_status == 1) {
                return 'fal fa-trophy'
            }
            else if (this.group_training_user_result_status == 2) {
                return 'fal fa-ban'
            }
        },

        getResultColor() {
            if (this.group_training_user_result_status == 1) {
                return 'positive'
            }
            else if (this.group_training_user_result_status == 2) {
                return 'negative'
            }
        },

        hasForum() {
            if (this.id_user_client_selected) {
                let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
                if (obj) {
                    return obj.has_forum
                }
            }
            return false
        },

        showDoubtsButton() {
            if (this.id_user_client_selected) {
                let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
                if (obj) {
                    return obj.course_doubts
                }
            } else return false
        }

    },

    methods: {
        fetchCourse() {
            this.$q.loading.show()

            let url = ''

            if (this.$route.name === 'course') {
                url = `/etraining_courses/group_training/${this.id_curse}/`
            }
            else if (this.$route.name === 'trail_course') {
                url = `/etraining_trails/trail/${this.id_trail}/group_training/${this.id_curse}/`
            }

            this.$axios.get(url, this.getHeader)
            .then(response => {
                this.course = response.data

                this.title = response.data.title
                this.description = response.data.description
                this.qty_group_training_activities = response.data.qty_group_training_activities
                this.qty_group_training_evaluations = response.data.qty_group_training_evaluations
                this.qty_group_training_materials = response.data.qty_group_training_materials
                this.qty_group_training_discussions = response.data.qty_topics
                this.user_progress = parseInt(response.data.user_progress)
                this.group_training_user_result_status = response.data.group_training_user_result_status
                this.group_training_user_result_date = date.formatDate(response.data.group_training_user_result_date, 'DD/MM/YYYY')
                this.owners = response.data.owners

                if (this.owners && this.owners.length < 1) {
                    this.owners = null
                }

                this.sections = []

                this.sections.push({
                    value: this.user_progress ? this.user_progress > 100 ? 100 : this.user_progress : 0,
                    color: this.getDonutColor(this.user_progress)
                })

                this.$q.loading.hide()
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)

                this.$q.notify({
                    message: this.$t('training_not_found'),
                    type: 'negative',
                    icon: 'fal fa-ban'
                })

                if (this.$route.name === 'course') this.$router.push({ name: 'courses' })
                else if (this.$route.name === 'trail_course') this.$router.push({ name: 'trail', params: { id: this.$route.params.id_trail } })
            })
        },

        getPercentage(percentage) {
            if (!percentage) {
                return 0
            }
            else if (percentage < 100) {
                return parseInt(percentage)
            }
        },

        getDonutColor(percentage) {
            if (percentage > 0 && percentage <= 24) {
                return '#DB2828'
            }
            else if (percentage >= 25 && percentage <= 74) {
                return '#F2C037'
            }
            else if(percentage >= 75) {
                return '#21BA45'
            }
        },

        reloadActivity() {
            if(this.$route.name == 'trail_course') {
                this.validatePercentTrails(this.$route.params.id_trail)

            }

            let url = ''
            if (this.$route.name === 'course') {
                url = `/etraining_courses/group_training/${this.id_curse}/get_group_training_user_progress/`
            }
            else if (this.$route.name === 'trail_course') {
                url = `/etraining_trails/trail/${this.id_trail}/group_training/${this.id_curse}/get_group_training_user_progress/`
            }

            this.$axios.get(url, this.getHeader)
            .then(response => {
                this.user_progress = response.data.user_progress ? parseInt(response.data.user_progress) : 0
                this.group_training_user_result_status = response.data.group_training_user_result_status

                this.sections = []

                if (this.group_training_user_result_status != 2) {
                    this.sections.push({
                        value: this.user_progress ? this.user_progress > 100 ? 100 : this.user_progress : 0,
                        color: this.getDonutColor(this.user_progress)
                    })
                }
                else {
                    this.sections.push({
                        value: 100,
                        color: '#DB2828'
                    })
                }

            })
            .catch(e => {
                console.log(e)
            })
        },

        showCertificate() {
            if (this.group_training_user_result_status == 1) {
                this.$q.loading.show()

                this.$axios.get(`/etraining_courses/group_training/${this.$route.params.id}/get_group_training_user_result_certificate/`, this.getHeader)
                .then(response => {
                    this.certificate = { group_training_title: this.title }
                    this.certificate_data = response.data
                    this.show_certificate = true
                    this.$q.loading.hide()
                })
                .catch(e => {
                    this.$q.loading.hide()
                    console.log(e)
                })
            }
        },

        hideCertificate() {
            this.show_certificate = false
            this.certificate_data = []
        },

        validatePercentTrails(idTrail) {
            this.$axios.get(`/etraining_trails/trails/${idTrail}/`, this.getHeader)
        },

        askQuestion() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let fd = new FormData()
                fd.append('message', this.message)

                this.$axios.post(`/etraining_courses/group_training/${this.id_curse}/set_doubt/`, fd, this.getHeader)
                .then(response => {
                    this.$q.loading.hide()
                    this.doubts_modal = false

                    this.$q.notify({
                        message: this.$t('message_send_success'),
                        type: 'positive',
                        icon: 'fal fa-save'
                    })

                })
                .catch(e => {
                    this.$q.loading.hide()
                    this.doubts_modal = false

                    this.$q.notify({
                        message: this.$t('message_send_error'),
                        type: 'negative',
                        icon: 'fal fa-ban'
                    })

                    console.log(e)
                })
            }
        }
    },

    created() {
        if (this.$route.name === 'course') {
            this.id_curse = Number(this.$route.params.id)
        }
        else if (this.$route.name === 'trail_course') {
            this.id_trail = Number(this.$route.params.id_trail)
            this.id_curse = Number(this.$route.params.id)
        }
        this.fetchCourse()

        if (this.access_token) {
            this.block_fields = true
            this.name = this.name_store
            this.email = this.email_store
        }
    },

    validations() {
        return {
            name: { required },
            email: { required, email },
            message: { required },
        }
    },

    watch: {
        $route: function (to, from) {
            if (this.$route.name === 'course') {
                this.id_curse = Number(this.$route.params.id)
            }
            else if (this.$route.name === 'trail_course') {
                this.id_trail = Number(this.$route.params.id_trail)
                this.id_curse = Number(this.$route.params.id)
            }

            this.fetchCourse()
        }
    },

    mounted() {
        if (this.$q.platform.is.cordova && this.$q.platform.is.android) {
            let storage_location = 'file:///storage/emulated/0/'
            let folder = 'Downloads/' + process.env.PROJECT_FOLDER + '/'

            downloader.init({folder: folder, fileSystem: storage_location, noMedia: false})
        }
    }
}
</script>

<style>

</style>
